module.exports = __webpack_public_path__ + "img/animals_02_H.fa4d9cbb.webp";